import React from 'react';
import './term.scss';

const Term = () => {
  return (
    <div className="term-parent parent">
     <div className="term-cont cont">
     <div className="term-conts">
        <h1>Terms and Conditions</h1>
      </div>
      
      <div className="term-cont2 ">
        <h3>Introduction</h3>
        <p>Welcome to Gandhi Travels. These terms and conditions govern your use of our website and services.</p>

        <h3>Acceptance of Terms</h3>
        <p>By accessing and using this website, you accept and agree to be bound by these terms. If you do not agree, do not use the website.</p>

        <h3>Changes to Terms</h3>
        <p>We may update our terms from time to time. Please check this page regularly for any changes.</p>

        <h3>Usage of Services</h3>
        <p>Our services are available to users who comply with the applicable laws and regulations.</p>

        <h3>Privacy and Data Collection</h3>
        <p>Your privacy is important to us. For more information, refer to our Privacy Policy.</p>

        <h3>Limitation of Liability</h3>
        <p>We are not liable for any damages that may occur through the use of our website or services.</p>

        <h3>Contact Information</h3>
        <p>If you have any questions or concerns regarding our terms, please contact us at:</p>
        <p>
          Email: <a href="mailto:gandhi26@gmail.com">gandhi26@gmail.com</a>
        </p>
        <p>
          Phone: <a href="tel:+918308988188">Call Us: +91 83089 88188</a>
        </p>
        <p>
          Website: <a href="https://gandhitravels.co.in/" target="_blank" rel="noopener noreferrer">https://gandhitravels.co.in/</a>
        </p>
      </div>
     </div>
    </div>
  );
};

export default Term;
